import MapHandler from '../MapHandler/MapHandler';
import EstimatesBaseTypeMap from '../EstimatesBaseTypeMap/EstimatesBaseTypeMap';
import { BudgetTypeEnum, STRING_CONF } from '../../../pojo-helpers/pojo-helper';

class EstimatesTypeMap extends EstimatesBaseTypeMap {
  constructor(...args) {
    super(...args);
  }
}

MapHandler.register(BudgetTypeEnum.Estimate, new EstimatesTypeMap(
  BudgetTypeEnum.Estimate,
  {
    labels: [STRING_CONF.ESTIMATE_LABEL_ESTIMATED_SPENDING, STRING_CONF.ESTIMATE_MENULIST_BREAKDOWN],
    labelHelpers: [STRING_CONF.ESTIMATE_MENULIST_BREAKDOWN_HELPER],
  },
  [{ numberFormat: '0.00' }],
  [{ breakdown: '' }],
));

export default EstimatesTypeMap;
